import React from 'react'
import PropTypes from 'prop-types'

const ReviseLockIcon = ({size = 16}) => {
  return (
    <svg width={size} height={size} fill="none">
      <path
        fill="#000"
        fillRule="evenodd"
        d="M9.99 1.826a1.959 1.959 0 0 1 2.77 2.77L4.876 12.48l-.037.037c-.18.181-.34.34-.531.458-.169.103-.352.18-.545.225-.218.053-.443.053-.699.052H1.962a.628.628 0 0 1-.628-.627v-1.103c0-.256 0-.48.052-.7.046-.192.122-.375.225-.544.117-.192.277-.35.458-.53l.037-.038L9.99 1.826Zm1.882.888a.704.704 0 0 0-.995 0l-7.884 7.884c-.238.238-.282.287-.312.336a.627.627 0 0 0-.075.182c-.013.055-.017.121-.017.458v.423h.423c.337 0 .403-.004.458-.017a.629.629 0 0 0 .182-.075c.048-.03.098-.074.336-.312l7.884-7.884a.704.704 0 0 0 0-.995Zm1.809 8.192c.256.234.273.631.04.887l-.628.687a2.329 2.329 0 0 1-1.718.772 2.329 2.329 0 0 1-1.718-.772 1.077 1.077 0 0 0-.793-.364c-.285 0-.571.124-.792.364a.628.628 0 1 1-.925-.848 2.332 2.332 0 0 1 1.717-.77c.656 0 1.272.284 1.718.77.221.242.508.365.793.365.285 0 .571-.123.791-.364l.628-.687a.628.628 0 0 1 .887-.04Z"
        clipRule="evenodd"
      />
    </svg>
  )
}

ReviseLockIcon.propTypes = {
  size: PropTypes.number,
}

export default ReviseLockIcon
